import React, { useEffect, useState } from "react";
import SlotBookingStatus from "../DialogComponent/index.jsx";
import { getSlots } from "../../../../Utils/apiServices.js";
import { useLocation } from "react-router-dom";

export default function DocumentPage() {
  const [currentMonth, setCurrentMonth] = useState(new Date()); 
  const [selectedDates, setSelectedDates] = useState([]); 
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const location = useLocation();
  const [loading, setLoading] = useState(false);



  const [slotsData, setSlotsData] = useState([]);

  useEffect(() => {
    const fetchSlotsData = async () => {
      try {
        setLoading(true);
        const response = await getSlots();
        console.log(response, "APIRawResponse");

        setSlotsData(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching documents:", error);
      }
    };
  
    fetchSlotsData();
  }, [])

  console.log("SlotsData:", slotsData);

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day);
    }
    return days;
  };

  const days = getDaysInMonth(currentMonth);

  const navigateMonth = (direction) => {
    setCurrentMonth((prev) => {
      const newMonth = new Date(prev);
      newMonth.setMonth(prev.getMonth() + direction);
      return newMonth;
    });
  };

  const slots = [
    { id: 1, label: "Morning", time: "09:00 AM IST" },
    { id: 2, label: "Morning", time: "12:00 PM IST" },
    { id: 3, label: "Afternoon", time: "02:00 PM IST" },
    { id: 4, label: "Afternoon", time: "03:45 PM IST" },
  ];
  const handleBookSlot = () => {
    console.log("Selected dates:", selectedDates, "Slot:", selectedSlot);
    if (!selectedDates.length || !selectedSlot) {
      setStatus("filled"); 
    } else {
      setStatus("success"); 
    }

    setDialogOpen(true); 
  };
  // Styles
  const containerStyle = {
    background: "#fff",
    borderRadius: 12,
    padding: 24,
    border: "1px solid rgba(224,224,224,1)",
    maxHeight: "80vh",
    overflowY: "auto",
    fontFamily: "Arial, sans-serif",
  };

  const headerRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  };

  const titleStyle = {
    fontWeight: 500,
    fontSize: "1rem",
    color: "rgba(88, 90, 100, 1)",
    margin: 0,
  };

  const programTitleStyle = {
    fontWeight: 600,
    color: "rgba(88, 90, 100, 1)",
    fontSize: "1rem",
    margin: 0,
  };

  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: "0.5fr 1fr 1fr 0.5fr",
    gap: 16,
    alignItems: "flex-start",
  };

  const calendarWrapperStyle = {
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: 12,
    width: "80%",
    gridColumn: "2",
  };

  const calendarHeaderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
    padding: "0 4px",
    borderBottom:'1px solid grey'
  };

  const navButtonStyle = {
    padding: 4,
    background: "none",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    color: "#6b7280",
    fontSize: "14px",
  };

  const monthYearStyle = {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#374151",
    margin: 0,
  };

  const weekDaysGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: 2,
    marginBottom: 8,
  };

  const weekDayStyle = {
    height: 26,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.7rem",
    fontWeight: 500,
    color: "#6b7280",
  };

  const daysGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: 1,
  };

  const getDayButtonStyle = (day, isAvailable, isSelected) => {
    let backgroundColor = "transparent";
    let color = "#9ca3af";
    let cursor = "not-allowed";

    if (isAvailable) {
      cursor = "pointer";
      if (isSelected) {
        backgroundColor = "rgba(65, 103, 39, 1)";
        color = "white";
      } else {
        backgroundColor = "rgba(198, 211, 189, 1)";
        color = "#059669";
      }
    }

    return {
      height: 26,
      width: 26,
      border: "none",
      borderRadius: 3,
      fontSize: "0.75rem",
      fontWeight: isSelected ? 600 : 400,
      backgroundColor,
      color,
      cursor,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s",
    };
  };

  const legendStyle = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginTop: 12,
  };

  const legendBoxStyle = {
    width: 14,
    height: 14,
    backgroundColor: "rgba(198, 211, 189, 1)",
    // border: "1px solid #a7f3d0",
    borderRadius: 3,
  };

  const slotsWrapperStyle = {
    gridColumn: "3",
    minWidth: 0,
  };

  const slotsHeaderStyle = {
    fontSize: "0.875rem",
    fontWeight: 500,
    marginBottom: 16,
    color: "#6b7280",
    fontStyle: "italic",
    margin: "0 0 16px 0",
  };

  const slotsGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 12,
  };

  const getSlotButtonStyle = (isSelected) => ({
    position: "relative",
    border: isSelected ? "2px solid rgba(50, 80, 31, 1)" : "1px solid #e5e7eb",
    borderRadius: 8,
    padding: 16,
    minHeight: 80,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: isSelected ? "rgba(237, 241, 234, 1)" : "#ffffff",
    transition: "all 0.2s",
  });

  const checkmarkStyle = {
    position: "absolute",
    top: 8,
    right: 8,
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: "rgba(65, 103, 39, 1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "0.75rem",
  };

  const slotLabelStyle = {
    fontSize: "0.75rem",
    fontWeight: 500,
    color: "#6b7280",
    marginBottom: 4,
  };

  const slotTimeStyle = {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#374151",
  };

  const dividerStyle = {
    border: "none",
    borderTop: "1px solid #e5e7eb",
    margin: "24px 0",
  };

  const noticeStyle = {
    background: "#f9fafb",
    padding: 24,
    borderRadius: 8,
    marginBottom: 24,
  };

  const noticeHeaderStyle = {
    fontSize: "0.875rem",
    fontWeight: 600,
    marginBottom: 12,
    color: "#374151",
  };

  const noticeListStyle = {
    margin: 0,
    paddingLeft: 20,
    color: "#6b7280",
    fontSize: "0.875rem",
  };

  const noticeItemStyle = {
    marginBottom: 4,
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "flex-end",
  };

  const bookButtonStyle = {
    backgroundColor: "rgba(65, 103, 39, 1)",
    color: "white",
    fontWeight: 600,
    padding: "12px 24px",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: "0.875rem",
    transition: "background-color 0.2s",
    marginBottom:'2rem'
  };

  return (
    <div style={containerStyle}>
      <div style={headerRowStyle}>
        <h1 style={titleStyle}>Book Interview Slot</h1>
        <h2 style={programTitleStyle}>
          MBA in Global Supply Chain Management (GSCM)
        </h2>
      </div>

      <hr
        style={{
          border: "none",
          borderTop: "1px solid #e5e7eb",
          margin: "0 0 20px 0",
        }}
      />

      <div style={gridContainerStyle}>
        <div style={calendarWrapperStyle}>
          <div style={calendarHeaderStyle}>
            <button style={navButtonStyle} onClick={() => navigateMonth(-1)}>
              ←
            </button>
            <h3 style={monthYearStyle}>
              {monthNames[currentMonth.getMonth()]}{" "}
              {currentMonth.getFullYear()}
            </h3>
            <button style={navButtonStyle} onClick={() => navigateMonth(1)}>
              →
            </button>
          </div>

          <div style={weekDaysGridStyle}>
            {weekDays.map((day) => (
              <div key={day} style={weekDayStyle}>
                {day}
              </div>
            ))}
          </div>

          <div style={daysGridStyle}>
            {days.map((day, index) => {
              if (day === null) {
                return <div key={index} style={{ height: 26 }}></div>;
              }

              const dayDate = new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth(),
                day
              );
              const today = new Date();
              today.setHours(0, 0, 0, 0); 

              const isAvailable = dayDate >= today; 
              const isSelected = selectedDates.includes(day);

              return (
                <button
                  key={day}
                  onClick={() => {
                    if (isAvailable) {
                      setSelectedDates((prev) =>
                        prev.includes(day)
                          ? prev.filter((d) => d !== day)
                          : [...prev, day]
                      );
                    }
                  }}
                  style={getDayButtonStyle(day, isAvailable, isSelected)}
                  disabled={!isAvailable}
                  onMouseOver={(e) => {
                    if (isAvailable && !isSelected) {
                      e.target.style.backgroundColor = "rgba(65, 103, 39, 1)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (isAvailable && !isSelected) {
                      e.target.style.backgroundColor = "rgba(198, 211, 189, 1)";
                    }
                  }}
                >
                  {day}
                </button>
              );
            })}
          </div>

          <div style={legendStyle}>
            <div style={legendBoxStyle}></div>
            <span style={{ fontSize: "0.75rem", color: "#374151" }}>
              Available dates
            </span>
          </div>
        </div>

        <div style={slotsWrapperStyle}>
          <p style={slotsHeaderStyle}>Immediately available slots</p>
          <div style={slotsGridStyle}>
            {slotsData.successMessage}
            {/* {slots.map((slot) => (
              <button
                key={slot.id}
                onClick={() => setSelectedSlot(slot.id)}
                style={getSlotButtonStyle(selectedSlot === slot.id)}
              >
                {selectedSlot === slot.id && (
                  <div style={checkmarkStyle}>✓</div>
                )}
                <div style={slotLabelStyle}>{slot.label}</div>
                <div style={slotTimeStyle}>{slot.time}</div>
              </button>
            ))} */}
          </div>
        </div>
      </div>

      <hr style={dividerStyle} />

      <div style={noticeStyle}>
        <p style={noticeHeaderStyle}>Please note:</p>
        <ul style={noticeListStyle}>
          <li style={noticeItemStyle}>
            You are viewing a limited selection of available slots for your
            session.
          </li>
          <li style={noticeItemStyle}>
            The displayed slots are the next available options at this time.
          </li>
          <li style={noticeItemStyle}>
            Select a slot that works best for you to proceed.
          </li>
          <li style={noticeItemStyle}>
            Additional slots may open later based on availability.
          </li>
        </ul>
      </div>

      <div style={buttonContainerStyle}>
        <button
          style={bookButtonStyle}
          onClick={handleBookSlot}
        >
          Book slot
        </button>
      </div>
      {status && (
        <SlotBookingStatus
          open={dialogOpen}
          status={status}
          onClose={() => setDialogOpen(false)}
        />
      )}
    </div>
  );
}
